import React, {
  createRef,
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { Flipper } from "react-flip-toolkit";
import * as TabGroupStyles from "./TabGroup.style";

var TabGroup = (_ref, ref) => {
  var _children$selected;

  var {
    children,
    className,
    disabled,
    initialTab = disabled ? undefined : 0,
    selectedTab,
    onTabClick,
    animate = true
  } = _ref;
  var [selected, setSelected] = useState(initialTab); // state is being controlled by the parent component

  useEffect(() => {
    if (typeof selectedTab !== "undefined") {
      setSelected(selectedTab);
    }
  }, [selectedTab]);
  var handleTabClick = useCallback(
    newTab => {
      // state is being controlled internally
      if (selectedTab === undefined) {
        setSelected(newTab);
      }

      if (onTabClick) {
        onTabClick(newTab);
      }
    },
    [onTabClick, selectedTab]
  );
  useImperativeHandle(ref || /*#__PURE__*/ createRef(), () => ({
    setTab: newTab => setSelected(newTab)
  }));
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Flipper,
      {
        flipKey: animate && selected
      },
      /*#__PURE__*/ React.createElement(
        TabGroupStyles.TabGroupUl,
        {
          className: className
        },
        React.Children.map(children, (tab, index) => {
          var _tab$props$disabled;

          return /*#__PURE__*/ React.cloneElement(tab, {
            disabled:
              (_tab$props$disabled = tab.props.disabled) !== null && _tab$props$disabled !== void 0
                ? _tab$props$disabled
                : disabled,
            index,
            selectedTab: selected,
            onTabClick: handleTabClick
          });
        })
      ),
      /*#__PURE__*/ React.createElement(
        TabGroupStyles.TabPanel,
        null,
        selected !== undefined &&
          ((_children$selected = children[selected]) === null || _children$selected === void 0
            ? void 0
            : _children$selected.props.children)
      )
    )
  );
};

export { TabGroupStyles };
export default /*#__PURE__*/ forwardRef(TabGroup);
